import React, {Fragment} from 'react'

import {
  EuiBreadcrumbs,
  EuiSpacer
} from '@elastic/eui'


export default function ManualBreadcrumbs() {

  const breadcrumbs = [
    {
      text: 'Android / BlackBerry',
      href: '/en/Downloads/Mobile_Apps/Android_BlackBerry/',
    },
    {
      text: 'iOS',
      href: '/en/Downloads/Mobile_Apps/iOS/',
    },
    {
      text: 'Windows',
      href: '/en/Downloads/Mobile_Apps/Windows_Phone/',
    },
    {
      text: 'Mobile Apps',
      href: '/en/Downloads/Mobile_Apps/',
    },
    {
      text: '◄ Downloads',
      href: '/en/Downloads/',
    }
  ];

  return (
    <Fragment>
      <EuiBreadcrumbs
        truncate={true}
        breadcrumbs={breadcrumbs}
        max={11}
        aria-label="Downloadbereich for your INSTAR IP Camera"
      />
      <EuiSpacer />
    </Fragment>
  );
}